











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {i18nMixin} from '@/modules/neodash/mixins';

@Component({
  name: 'FilterContainer'
})
export default class FilterContainer extends Vue {
  public readonly translate = i18nMixin.methods.i18n;
  public readonly keyLabelFilter: string = 'Action.Filter';
  public keyLabelActionButton: string;

  @Prop({required: true})
  formValid: boolean;

  @Prop({required: false})
  labelAction: string;

  @Watch('labelAction')
  public updateLabel(): void {
    this.keyLabelActionButton = this.labelAction;
  }

  public created(): void {
    this.keyLabelActionButton = this.labelAction !== undefined ? this.labelAction : this.keyLabelFilter;
  }

  public handleClick() {
    this.$emit('click');
  }
}
